export default __webpack_public_path__ + "static/media/job_centrum_symbol.e8c11ed8.svg";